import React, { useState, useEffect } from 'react';
import { useLocation, useHistory } from 'react-router-dom';
import clsx from 'clsx';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft } from '@fortawesome/free-solid-svg-icons';
import BusinessSettingsTitle from '../../UI/BusinessSettingsTitle';
import { TagsNavbar } from '../Navbar/Navbar';
import EntityTags from '../EntityTags/EntityTags';
import styles from './Tags.module.scss';
import { useSelector } from 'react-redux';
import { RootState } from 'store';

export interface TagsProps {
    personalities?: Array<string>;
    onSavePetPositivePersonality?: (personalities: Array<string>) => void;
    onSavePetNegativePersonality?: (personalities: Array<string>) => void;
    onSaveClientPositivePersonality?: (personalities: Array<string>) => void;
    onSaveClientNegativePersonality?: (personalities: Array<string>) => void;
    className?: string;
    openSidebar?: () => void;
    isMobile?: boolean;
}

export const Tags: React.FC<TagsProps> = ({
    onSavePetPositivePersonality,
    onSavePetNegativePersonality,
    onSaveClientPositivePersonality,
    onSaveClientNegativePersonality,
    className,
    openSidebar,
    isMobile
}) => {
    const location = useLocation();
    const history = useHistory();

    // Read URL parameter and set initial tab
    const getInitialTab = (): 'pets' | 'clients' => {
        const searchParams = new URLSearchParams(location.search);
        const typeParam = searchParams.get('type');
        return typeParam === 'clients' ? 'clients' : 'pets';
    };

    const [selectedTab, setSelectedTab] = useState<'pets' | 'clients'>(getInitialTab());

    // Update URL when coming from a direct link or refresh
    useEffect(() => {
        const searchParams = new URLSearchParams(location.search);
        const typeParam = searchParams.get('type');
        if (typeParam === 'clients' || typeParam === 'pets') {
            setSelectedTab(typeParam);
        }
    }, [location.search]);

    // Handle tab change and update URL
    const handleTabChange = (tab: 'pets' | 'clients') => {
        setSelectedTab(tab);
        const searchParams = new URLSearchParams(location.search);
        searchParams.set('type', tab);
        history.replace({ search: searchParams.toString() });
    };

    const description = 'Add the tags that you want to set for clients and their pets.';

    return (
        <div className={clsx(styles.container, className)}>
            <div className={styles.titleContainer}>
                <BusinessSettingsTitle className={styles.businessSettingsTitle}>
                    {isMobile && (
                        <FontAwesomeIcon
                            className={styles.iconBusinessTitle}
                            onClick={openSidebar}
                            icon={faArrowLeft}
                            size="2x"
                        />
                    )}
                    Tags
                </BusinessSettingsTitle>
                <p className={styles.description}>{description}</p>
                <TagsNavbar
                    onTabChange={handleTabChange}
                    selectedTab={selectedTab}
                />
                {selectedTab === 'pets' && (
                    <EntityTags
                        entityType="pet"
                        onSavePositivePersonality={onSavePetPositivePersonality}
                        onSaveNegativePersonality={onSavePetNegativePersonality}
                        openSidebar={openSidebar}
                        isMobile={isMobile}
                    />
                )}
                {selectedTab === 'clients' && (
                    <EntityTags
                        entityType="client"
                        onSavePositivePersonality={onSaveClientPositivePersonality}
                        onSaveNegativePersonality={onSaveClientNegativePersonality}
                        openSidebar={openSidebar}
                        isMobile={isMobile}
                    />
                )}
            </div>
        </div>
    );
};

export default Tags;
